import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import {
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@material-ui/core'
import CodeView from '../CodeView'

import styles from './styles'

const DirectLinkWidget = ({ classes, config, onConfigChange }) => {
  const handleDirectLinkTargetChange = event => {
    onConfigChange({
      ...config,
      directLinkTarget: event.target.value,
    })
  }

  return (
    <div className={classes.root}>
      <FormControl variant="outlined" className={classes.mobileSelect}>
        <InputLabel>Direct Link Target</InputLabel>
        <Select
          label="Direct Link Target"
          value={config?.directLinkTarget || '_blank'}
          onChange={handleDirectLinkTargetChange}
          className={classes.select}
        >
          <MenuItem value="_blank" className={classes.menuItem}>
            <Typography>_blank</Typography>
          </MenuItem>
          <MenuItem value="_self" className={classes.menuItem}>
            <Typography>_self</Typography>
          </MenuItem>
        </Select>
      </FormControl>
      <CodeView
        label="HTML"
        buttonLabel="Copy HTML code"
        widgetType="direct"
        config={config}
      />
      <CodeView
        label="JavaScript"
        buttonLabel="Copy JavaScript code"
        widgetType="direct"
        config={config}
      />
    </div>
  )
}

export default withStyles(styles)(DirectLinkWidget)
